import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M11.86 5.188 9.03 8l2.828 2.813c.094.104.141.223.141.359 0 .135-.047.25-.14.344l-.344.343a.468.468 0 0 1-.344.141.522.522 0 0 1-.36-.14L8 9.03 5.187 11.86a.522.522 0 0 1-.359.141.468.468 0 0 1-.344-.14l-.343-.344A.467.467 0 0 1 4 11.172c0-.136.047-.255.14-.36L6.97 8 4.14 5.187A.522.522 0 0 1 4 4.829c0-.135.047-.25.14-.344l.344-.343A.468.468 0 0 1 4.828 4c.136 0 .255.047.36.14L8 6.97l2.813-2.828A.522.522 0 0 1 11.171 4c.135 0 .25.047.344.14l.343.344c.094.094.141.209.141.344a.522.522 0 0 1-.14.36Z"
    }, null, -1)
  ])))
}
export default { render: render }